module.exports = __webpack_public_path__ + "img/924-223d80.png";